import { FunctionComponent } from 'react';
import { Logo } from './Logo';
interface PoweredByProps {}

const PoweredBy: FunctionComponent<PoweredByProps> = () => {
  return (
    <div className="flex flex-col items-center">
      <p className="text-xs">Powered By</p>
      <Logo className="w-44" />
    </div>
  );
};

export default PoweredBy;
